import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {LOCALE_ID, NgModule} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {BrowserModule} from '@angular/platform-browser';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';
import {LoaderInterceptor} from './interceptors/loader.interceptor';
import {NgxEchartsModule} from 'ngx-echarts';
import {LoaderModule} from './shared/modules/loader/loader.module';
import {FullCalendarModule} from '@fullcalendar/angular';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {NgxMaskModule} from 'ngx-mask';
import { SuccessComponent } from './modules/success/success.component';


@NgModule({
  declarations: [
    AppComponent,
    SuccessComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    HttpClientModule,
    SharedModule,
    FullCalendarModule,
    NgxMaskModule.forRoot(),
    NgxEchartsModule.forRoot({
      /**
       * This will import all modules from echarts.
       * If you only need custom modules,
       * please refer to [Custom Build] section.
       */
      echarts: () => import('echarts'), // or import('./path-to-my-custom-echarts')
    }),
    LoaderModule
  ],
  providers: [
    HttpClientModule,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    SharedModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
